// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Research_page__z80sE {
  --container: calc(1160px + 2 * var(--gutter));
}

div.Research_content__Ge5dC {
  gap: 4rem;
}

.Research_content__Ge5dC h2 {
  font-size: clamp(1.5rem, 2.5vw, 2rem);
  line-height: 1.25;
}

.Research_content__Ge5dC figure {
  margin: 0;
}

.Research_content__Ge5dC figcaption {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin-top: 0.75rem;
}

.Research_hero__haqZ1 {
  margin-bottom: -2rem;
}

.Research_hero__haqZ1 .Research_trialButton__eKoSM {
  color: white;
}

.Research_hero__haqZ1 .Research_trialButton__eKoSM:hover {
  background: var(--primary-dark);
}

.Research_source__FHDFX {
  margin: 1rem 0 0;
  font-size: 0.9375rem;
  color: var(--text-secondary);
}

.Research_source__FHDFX a svg {
  margin-left: 0.25rem;
  vertical-align: middle;
}

.Research_figures__cf3Bt .ui-fact-value {
  order: -1;
  font-size: clamp(1.5rem, 3vw, 2.25rem);
  color: var(--primary);
}

.Research_bento__f5n\\+o {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.Research_bento__f5n\\+o > :nth-child(1) {
  grid-column: 1 / -1;
}

.Research_bento__f5n\\+o > :nth-child(2) {
  grid-column: span 2;
}

.Research_bento__f5n\\+o > :nth-child(3) {
  grid-column: span 4;
}

.Research_everydayPhoto__d-J0M {
  min-width: 0;
  align-self: start;
}

.Research_everydayPhoto__d-J0M img,
.Research_placeholder__fAW6l {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: var(--radius-lg);
}

.Research_placeholder__fAW6l {
  background: #f5f5f5;
}

.Research_tasks__jya61 {
  background: #fafafa;
  padding: 2rem;
  justify-content: center;
  gap: 1.5rem;
}

.Research_tasks__jya61 h3 {
  font-size: 1.25rem;
}

.Research_tasks__jya61 ul {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  list-style: none;
  gap: 1rem;
  padding: 0;
  margin: 0;
}

.Research_tasks__jya61 li {
  border-top: 1px solid var(--border);
  padding-block: 1rem;
  font-size: 1.0625rem;
}

.Research_note__5a9xc {
  margin-top: 1.5rem;
}

.Research_lead__\\+K08t {
  margin: 0.75rem 0 2rem;
}

.Research_measured__U9XXj {
  scroll-margin-top: 5rem;
}

.Research_outcomeLayout__t8t4e {
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 1.5rem;
  align-items: stretch;
}

.Research_tiles__e-61\\+ {
  grid-column: span 5;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-content: center;
  gap: 0.75rem;
  margin: 0;
  min-width: 0;
}

.Research_measurePhoto__61BD\\+ {
  grid-column: span 7;
  min-width: 0;
}

.Research_measurePhoto__61BD\\+ img {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-radius: var(--radius-lg);
  display: block;
}

.Research_quote__7q0Vh {
  border-left: 4px solid var(--primary);
  margin: 2rem 0 0;
  padding: 0.5rem 0 0.5rem 1.5rem;
  font-size: 1.5rem;
  line-height: 1.6;
}

@media (max-width: 1023px) {
  .Research_outcomeLayout__t8t4e {
    grid-template-columns: minmax(0, 1fr);
  }

  .Research_measurePhoto__61BD\\+,
  .Research_tiles__e-61\\+ {
    grid-column: auto;
  }

  .Research_bento__f5n\\+o > :nth-child(2),
  .Research_bento__f5n\\+o > :nth-child(3) {
    grid-column: span 3;
  }
}

@media (max-width: 820px) {
  .Research_hero__haqZ1.ui-hero-panel--split {
    grid-template-columns: minmax(0, 1fr);
  }

  .Research_hero__haqZ1.ui-hero-panel--split > .ui-hero-media {
    order: 0;
    aspect-ratio: 4 / 3;
    margin: 0 calc(-1 * var(--space-5)) calc(-1 * var(--space-5));
  }
}

@media (max-width: 767px) {
  div.Research_content__Ge5dC {
    gap: 3rem;
  }

  .Research_bento__f5n\\+o,
  .Research_tiles__e-61\\+ {
    grid-template-columns: minmax(0, 1fr);
  }

  .Research_bento__f5n\\+o > :nth-child(n) {
    grid-column: auto;
  }

  .Research_tasks__jya61 {
    padding: 1.5rem;
  }

  .Research_tasks__jya61 ul {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .Research_quote__7q0Vh {
    font-size: 1.25rem;
  }
}

/* Phones: tighter rhythm, smaller type, outcome tiles two-up. */
@media (max-width: 560px) {
  div.Research_content__Ge5dC {
    gap: 2.25rem;
  }

  .Research_content__Ge5dC h2 {
    font-size: 1.25rem;
  }

  .Research_content__Ge5dC figcaption {
    font-size: 0.8125rem;
    margin-top: 0.5rem;
  }

  .Research_hero__haqZ1 {
    margin-bottom: -1rem;
  }

  .Research_hero__haqZ1.ui-hero-panel--split > .ui-hero-media {
    aspect-ratio: 16 / 10;
    margin: 0 calc(-1 * var(--space-4)) calc(-1 * var(--space-4));
  }

  .Research_figures__cf3Bt .ui-fact-value {
    font-size: 1.35rem;
  }

  .Research_bento__f5n\\+o {
    gap: 1rem;
    margin-top: 1.25rem;
  }

  .Research_everydayPhoto__d-J0M img,
  .Research_placeholder__fAW6l,
  .Research_measurePhoto__61BD\\+ img {
    aspect-ratio: 16 / 10;
    border-radius: var(--radius-md);
  }

  .Research_tasks__jya61 {
    padding: 1.125rem;
    gap: 1rem;
  }

  .Research_tasks__jya61 h3 {
    font-size: 1.0625rem;
  }

  .Research_tasks__jya61 ul {
    gap: 0 0.75rem;
  }

  .Research_tasks__jya61 li {
    padding-block: 0.625rem;
    font-size: 0.875rem;
  }

  .Research_lead__\\+K08t {
    margin: 0.5rem 0 1.25rem;
  }

  .Research_outcomeLayout__t8t4e {
    gap: 1rem;
  }

  .Research_tiles__e-61\\+ {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.625rem;
  }

  .Research_quote__7q0Vh {
    margin-top: 1.25rem;
    padding: 0.25rem 0 0.25rem 1rem;
    border-left-width: 3px;
    font-size: 1.0625rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/Research.module.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;AAC/C;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,QAAQ;IACR,mBAAmB;IACnB,6DAA6D;EAC/D;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;IACrB,6DAA6D;EAC/D;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;;;IAGE,qBAAqB;IACrB,+BAA+B;EACjC;;EAEA;IACE,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gDAAgD;IAChD,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,+BAA+B;IAC/B,sBAAsB;IACtB,oBAAoB;EACtB;AACF","sourcesContent":[".page {\n  --container: calc(1160px + 2 * var(--gutter));\n}\n\ndiv.content {\n  gap: 4rem;\n}\n\n.content h2 {\n  font-size: clamp(1.5rem, 2.5vw, 2rem);\n  line-height: 1.25;\n}\n\n.content figure {\n  margin: 0;\n}\n\n.content figcaption {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  margin-top: 0.75rem;\n}\n\n.hero {\n  margin-bottom: -2rem;\n}\n\n.hero .trialButton {\n  color: white;\n}\n\n.hero .trialButton:hover {\n  background: var(--primary-dark);\n}\n\n.source {\n  margin: 1rem 0 0;\n  font-size: 0.9375rem;\n  color: var(--text-secondary);\n}\n\n.source a svg {\n  margin-left: 0.25rem;\n  vertical-align: middle;\n}\n\n.figures :global(.ui-fact-value) {\n  order: -1;\n  font-size: clamp(1.5rem, 3vw, 2.25rem);\n  color: var(--primary);\n}\n\n.bento {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 1.5rem;\n  margin-top: 2rem;\n}\n\n.bento > :nth-child(1) {\n  grid-column: 1 / -1;\n}\n\n.bento > :nth-child(2) {\n  grid-column: span 2;\n}\n\n.bento > :nth-child(3) {\n  grid-column: span 4;\n}\n\n.everydayPhoto {\n  min-width: 0;\n  align-self: start;\n}\n\n.everydayPhoto img,\n.placeholder {\n  display: block;\n  width: 100%;\n  height: auto;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n  border-radius: var(--radius-lg);\n}\n\n.placeholder {\n  background: #f5f5f5;\n}\n\n.tasks {\n  background: #fafafa;\n  padding: 2rem;\n  justify-content: center;\n  gap: 1.5rem;\n}\n\n.tasks h3 {\n  font-size: 1.25rem;\n}\n\n.tasks ul {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  list-style: none;\n  gap: 1rem;\n  padding: 0;\n  margin: 0;\n}\n\n.tasks li {\n  border-top: 1px solid var(--border);\n  padding-block: 1rem;\n  font-size: 1.0625rem;\n}\n\n.note {\n  margin-top: 1.5rem;\n}\n\n.lead {\n  margin: 0.75rem 0 2rem;\n}\n\n.measured {\n  scroll-margin-top: 5rem;\n}\n\n.outcomeLayout {\n  display: grid;\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n  gap: 1.5rem;\n  align-items: stretch;\n}\n\n.tiles {\n  grid-column: span 5;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  align-content: center;\n  gap: 0.75rem;\n  margin: 0;\n  min-width: 0;\n}\n\n.measurePhoto {\n  grid-column: span 7;\n  min-width: 0;\n}\n\n.measurePhoto img {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n  border-radius: var(--radius-lg);\n  display: block;\n}\n\n.quote {\n  border-left: 4px solid var(--primary);\n  margin: 2rem 0 0;\n  padding: 0.5rem 0 0.5rem 1.5rem;\n  font-size: 1.5rem;\n  line-height: 1.6;\n}\n\n@media (max-width: 1023px) {\n  .outcomeLayout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .measurePhoto,\n  .tiles {\n    grid-column: auto;\n  }\n\n  .bento > :nth-child(2),\n  .bento > :nth-child(3) {\n    grid-column: span 3;\n  }\n}\n\n@media (max-width: 820px) {\n  .hero:global(.ui-hero-panel--split) {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .hero:global(.ui-hero-panel--split) > :global(.ui-hero-media) {\n    order: 0;\n    aspect-ratio: 4 / 3;\n    margin: 0 calc(-1 * var(--space-5)) calc(-1 * var(--space-5));\n  }\n}\n\n@media (max-width: 767px) {\n  div.content {\n    gap: 3rem;\n  }\n\n  .bento,\n  .tiles {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .bento > :nth-child(n) {\n    grid-column: auto;\n  }\n\n  .tasks {\n    padding: 1.5rem;\n  }\n\n  .tasks ul {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .quote {\n    font-size: 1.25rem;\n  }\n}\n\n/* Phones: tighter rhythm, smaller type, outcome tiles two-up. */\n@media (max-width: 560px) {\n  div.content {\n    gap: 2.25rem;\n  }\n\n  .content h2 {\n    font-size: 1.25rem;\n  }\n\n  .content figcaption {\n    font-size: 0.8125rem;\n    margin-top: 0.5rem;\n  }\n\n  .hero {\n    margin-bottom: -1rem;\n  }\n\n  .hero:global(.ui-hero-panel--split) > :global(.ui-hero-media) {\n    aspect-ratio: 16 / 10;\n    margin: 0 calc(-1 * var(--space-4)) calc(-1 * var(--space-4));\n  }\n\n  .figures :global(.ui-fact-value) {\n    font-size: 1.35rem;\n  }\n\n  .bento {\n    gap: 1rem;\n    margin-top: 1.25rem;\n  }\n\n  .everydayPhoto img,\n  .placeholder,\n  .measurePhoto img {\n    aspect-ratio: 16 / 10;\n    border-radius: var(--radius-md);\n  }\n\n  .tasks {\n    padding: 1.125rem;\n    gap: 1rem;\n  }\n\n  .tasks h3 {\n    font-size: 1.0625rem;\n  }\n\n  .tasks ul {\n    gap: 0 0.75rem;\n  }\n\n  .tasks li {\n    padding-block: 0.625rem;\n    font-size: 0.875rem;\n  }\n\n  .lead {\n    margin: 0.5rem 0 1.25rem;\n  }\n\n  .outcomeLayout {\n    gap: 1rem;\n  }\n\n  .tiles {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 0.625rem;\n  }\n\n  .quote {\n    margin-top: 1.25rem;\n    padding: 0.25rem 0 0.25rem 1rem;\n    border-left-width: 3px;\n    font-size: 1.0625rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Research_page__z80sE`,
	"content": `Research_content__Ge5dC`,
	"hero": `Research_hero__haqZ1`,
	"trialButton": `Research_trialButton__eKoSM`,
	"source": `Research_source__FHDFX`,
	"figures": `Research_figures__cf3Bt`,
	"bento": `Research_bento__f5n+o`,
	"everydayPhoto": `Research_everydayPhoto__d-J0M`,
	"placeholder": `Research_placeholder__fAW6l`,
	"tasks": `Research_tasks__jya61`,
	"note": `Research_note__5a9xc`,
	"lead": `Research_lead__+K08t`,
	"measured": `Research_measured__U9XXj`,
	"outcomeLayout": `Research_outcomeLayout__t8t4e`,
	"tiles": `Research_tiles__e-61+`,
	"measurePhoto": `Research_measurePhoto__61BD+`,
	"quote": `Research_quote__7q0Vh`
};
export default ___CSS_LOADER_EXPORT___;
